var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgP3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_126",
    "data-name": "Group 126",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116.081,
    height: 90.469,
    viewBox: "0 0 116.081 90.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 116.081,
    height: 90.469,
    fill: "#212968"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M44.766,228.6a6.733,6.733,0,0,0-4.256-4.231l-6.954-2.286a4.3,4.3,0,0,1-2.882-3.3l-.585-3.158a15.854,15.854,0,0,0,3.89-10.762c0-4.516-.878-7.98-2.608-10.3C29.6,192.2,26.945,191,23.475,191s-6.128,1.2-7.9,3.57c-1.731,2.317-2.608,5.781-2.608,10.3a15.854,15.854,0,0,0,3.889,10.76l-.584,3.161a4.284,4.284,0,0,1-2.881,3.3l-6.953,2.286A6.716,6.716,0,0,0,2.185,228.6L.1,234.818a1.932,1.932,0,1,0,3.663,1.23l2.084-6.218a2.848,2.848,0,0,1,1.8-1.791l6.953-2.286a8.155,8.155,0,0,0,5.475-6.267l.257-1.391a8.1,8.1,0,0,0,6.285,0l.257,1.391a8.153,8.153,0,0,0,5.473,6.266L39.3,228.04a2.858,2.858,0,0,1,1.8,1.793l2.084,6.215a1.932,1.932,0,1,0,3.663-1.23ZM26.559,213.717a4.717,4.717,0,0,1-6.185-.013,1.933,1.933,0,0,0-.382-.33c-1.893-1.764-3.157-4.918-3.157-8.509,0-8.814,3.357-10,6.64-10s6.638,1.188,6.638,10a11.775,11.775,0,0,1-3.146,8.5,1.911,1.911,0,0,0-.409.353",
    transform: "translate(0 -146.897)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M225.852,228.6a6.733,6.733,0,0,0-4.256-4.231l-6.954-2.286a4.291,4.291,0,0,1-2.88-3.3l-.583-3.161a15.852,15.852,0,0,0,3.889-10.76c0-4.516-.878-7.981-2.608-10.3-1.77-2.369-4.426-3.57-7.9-3.57s-6.128,1.2-7.9,3.57c-1.731,2.317-2.608,5.782-2.608,10.3a15.852,15.852,0,0,0,3.889,10.759l-.584,3.162a4.288,4.288,0,0,1-2.879,3.3l-2.879.946a1.932,1.932,0,1,0,1.206,3.67l2.88-.946a8.153,8.153,0,0,0,5.473-6.267l.257-1.391a8.1,8.1,0,0,0,6.285,0l.257,1.391a8.152,8.152,0,0,0,5.473,6.266l6.953,2.285a2.857,2.857,0,0,1,1.8,1.793l2.084,6.215a1.932,1.932,0,0,0,3.664-1.23Zm-18.195-14.894a4.72,4.72,0,0,1-6.195,0,1.921,1.921,0,0,0-.387-.334c-1.891-1.764-3.154-4.917-3.154-8.506,0-8.814,3.357-10,6.64-10s6.64,1.188,6.64,10c0,3.588-1.262,6.74-3.152,8.5a1.918,1.918,0,0,0-.392.338",
    transform: "translate(-146.339 -146.897)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M376.852,234.819l-2.084-6.216a6.734,6.734,0,0,0-4.257-4.231l-6.954-2.285a4.3,4.3,0,0,1-2.882-3.3l-.584-3.158a15.851,15.851,0,0,0,3.892-10.763c0-4.516-.878-7.981-2.608-10.3-1.769-2.369-4.427-3.57-7.9-3.57s-6.128,1.2-7.9,3.57c-1.731,2.317-2.608,5.781-2.608,10.3a15.852,15.852,0,0,0,3.889,10.759l-.584,3.162a4.284,4.284,0,0,1-2.881,3.3l-2.878.946a1.932,1.932,0,1,0,1.208,3.669l2.878-.946a8.155,8.155,0,0,0,5.475-6.266l.257-1.391a8.1,8.1,0,0,0,6.285,0l.257,1.391a8.152,8.152,0,0,0,5.473,6.266l6.953,2.286a2.857,2.857,0,0,1,1.8,1.792l2.084,6.216a1.932,1.932,0,1,0,3.663-1.23m-20.294-21.1a4.718,4.718,0,0,1-6.179-.014,1.934,1.934,0,0,0-.387-.334c-1.891-1.764-3.154-4.917-3.154-8.506,0-8.814,3.357-10,6.64-10s6.64,1.188,6.64,10a11.775,11.775,0,0,1-3.145,8.5,1.9,1.9,0,0,0-.414.357",
    transform: "translate(-260.871 -146.898)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M39.007,40.175H127.56c3.411,0,6.187-3.209,6.187-7.153V7.151c0-3.943-2.775-7.151-6.187-7.151H39.007c-3.41,0-6.184,3.208-6.184,7.151V33.022c0,3.944,2.774,7.153,6.184,7.153m-2.319-7.153V7.151c0-1.781,1.062-3.286,2.319-3.286H127.56c1.237,0,2.321,1.535,2.321,3.286V33.022c0,1.782-1.063,3.288-2.321,3.288H39.007c-1.257,0-2.319-1.506-2.319-3.288",
    transform: "translate(-25.244)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M73.421,54.97a1.914,1.914,0,0,0,1.147-.38l11.967-8.845a.524.524,0,0,1,.617,0l3.573,2.643a4.375,4.375,0,0,0,5.209,0l9.366-6.922a.512.512,0,0,1,.615,0l3.618,2.674a4.358,4.358,0,0,0,5.213,0l14.3-10.569a1.932,1.932,0,1,0-2.3-3.106l-14.3,10.566a.519.519,0,0,1-.62,0l-3.618-2.674a4.358,4.358,0,0,0-5.213,0l-9.364,6.921a.524.524,0,0,1-.617,0l-3.573-2.642a4.361,4.361,0,0,0-5.21,0L72.27,51.484a1.932,1.932,0,0,0-.4,2.7,1.94,1.94,0,0,0,1.555.784",
    transform: "translate(-54.981 -23.136)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M339.022,82.493h15.906a1.933,1.933,0,1,0,0-3.866H339.022a1.933,1.933,0,0,0,0,3.866",
    transform: "translate(-259.256 -60.472)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M320.216,114.733H293.89a1.933,1.933,0,0,0,0,3.866h26.326a1.933,1.933,0,1,0,0-3.866",
    transform: "translate(-224.545 -88.242)",
    fill: "#212968"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP3);
export default __webpack_public_path__ + "static/media/p-3.a93c02ec02518dd2b7cacc2a6efd0495.svg";
export { ForwardRef as ReactComponent };